import { DiscoverItemCard } from 'utils/gloo-types';
import DiscoverCardPreview from 'pages/_AdminAuthoringPages/_components/DiscoverCardPreview';
import Typography from 'components/atoms/Typography';

function DiscoverListPreview({
  cardWrapperStyleClassName,
  cardStyleClassName,
  typographyStyleClassName,
  title,
  itemCards,
  onClick,
}: {
  cardStyleClassName?: string;
  cardWrapperStyleClassName?: string;
  typographyStyleClassName?: string;
  title?: string;
  itemCards: DiscoverItemCard[];
  onClick: (itemCard: DiscoverItemCard) => void;
}) {
  if (itemCards.length === 0) return null;
  return (
    <>
      {title && (
        <Typography className={typographyStyleClassName || 'mt-8 mb-4 ml-2 text-center md:text-left'} variant="h2">
          {title}
        </Typography>
      )}
      <div className={cardWrapperStyleClassName || 'flex flex-row flex-wrap items-stretch'}>
        {itemCards.map((i, idx) => {
          return (
            <DiscoverCardPreview
              className={cardStyleClassName}
              key={`${i.discoverType}_${i.itemId}-${idx}`}
              itemCard={i}
              onClick={onClick}
            />
          );
        })}
      </div>
    </>
  );
}

export default DiscoverListPreview;
